import { HStack, Link, Text } from '@vimeo/bokeh';

import type { Tag } from '../../types';

export const Tags = ({ tags, showLinks }: { tags: Tag[]; showLinks?: boolean }) => (
  <HStack as="p" flexWrap="wrap" fontSize="text-sm">
    {showLinks
      ? tags.map((tag) =>
          tag?.name ? (
            <Link key={tag.canonical} variant="secondary" href={`/tag:${tag.name}`}>
              {'#'}
              {tag.name}
            </Link>
          ) : null,
        )
      : tags.map((tag) =>
          tag?.name ? (
            <Text
              variant="body-xl"
              as="span"
              key={tag.canonical}
              color="text-secondary"
              fontSize="text-sm"
            >
              {'#'}
              {tag.name}
            </Text>
          ) : null,
        )}
  </HStack>
);
